export default function getHost(platform: string): string {
  // This is a hack to get the parent URL
  const href =
    window.location != window.parent.location ? document.referrer : document.location.href;
  if (href === null) {
    return platform;
  }
  const url = new URL(href);
  const adminRegex = /^\/(app|horizon-ui)(\/|\?)?/;
  const adminMatch = url.pathname.match(adminRegex);
  if (adminMatch !== null) {
    return `${url.host}/app`;
  }
  const brandSlugRegex = /^\/b\/[^/]+\//;
  const brandSlugMatch = url.pathname.match(brandSlugRegex);
  if (brandSlugMatch !== null) {
    return `${url.host}${brandSlugMatch[0]}`;
  }
  // Setting the client to WEB if the host is not provided, eg. for the preview or standalone dev app or if the host is not a valid URL
  return url.host || platform;
}
